import { asyncRouterMap, constantRouterMap } from "@/router";

import Layout from "@/views/layout/Layout";

/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role));
  } else {
    return true;
  }
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param routes asyncRouterMap
 * @param roles
 */
function filterAsyncRouter(routes, roles) {
  const res = [];

  routes.forEach(route => {
    const tmp = {
      ...route
    };
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRouter(tmp.children, roles);
      }
      res.push(tmp);
    }
  });

  return res;
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
    }
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise(resolve => {
        const { roles } = data;
        let accessedRouters;
        if (roles.includes("admin")) {
          accessedRouters = asyncRouterMap;
        } else {
          accessedRouters = filterAsyncRouter(asyncRouterMap, roles);
        }

        ////// [[ 正常的
        commit("SET_ROUTERS", accessedRouters);
        resolve();
        ////// ]] 正常的

        ///// [[ 动态添加报表路由  模拟异步
        // setTimeout(() => {
        //   console.log('生成的路由1', accessedRouters)
        //   let bbRouter = {
        //     path: '/reportForm',
        //     component: Layout,
        //     name: 'reportForm',
        //     // redirect: '/dataDic/departMan',
        //     // component: () => import('@/views/dataDic/index'),
        //     meta: {
        //       title: '报表',
        //       icon: 'example',
        //       roles: ['pingtaiguanli']
        //     },
        //     children: []
        //   }
        //   let arr = [
        //     { name: '报表1', path: 'a1', iframeUrl: 'http://39.106.30.86:8080/webroot/decision/view/report?viewlet=1.cpt' },
        //     { name: '报表2', path: 'a2', iframeUrl: 'http://39.106.30.86:8080/webroot/decision/view/report?viewlet=1.cpt' },
        //     { name: '报表3', path: 'a3', iframeUrl: 'http://39.106.30.86:8080/webroot/decision/view/report?viewlet=1.cpt' },
        //   ]

        //   for (let item of arr) {
        //     let obj = {
        //       path: item.path,
        //       component: () => import('@/views/reportForm/form1'),
        //       name: item.name,
        //       meta: {
        //         title: item.name,
        //         iframeUrl: item.iframeUrl,
        //         roles: ['xinchouguanli']
        //       },
        //       children: []
        //     }
        //     bbRouter.children.push(obj)
        //   }

        //   accessedRouters.push(bbRouter)
        //   commit('SET_ROUTERS', accessedRouters)
        //   resolve()
        // }, 2000)
        ///// ]] 动态添加报表路由  模拟异步
      });
    }
  }
};

export default permission;
